import { BUTTON_VARIANTS } from 'ui/button';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { Tooltip } from 'ui/tooltip';
import { getCampaignEditorExperimentsSectionLink } from 'utils/appRoutes';
import { CampaignState } from 'modules/domains/campaign';

import { BaseCellWrapper, ChooseCampaignButton } from '../../styled';

export const ChooseCampaignCell = ({
  isDisabled,
  ruleViolation,
  id,
  campaignState,
}: {
  isDisabled: boolean;
  ruleViolation: string;
  id: number;
  campaignState: CampaignState;
}) => {
  const { t } = useExperimentsTranslations();

  return (
    <BaseCellWrapper>
      <Tooltip isEnabled={isDisabled} tooltipContent={ruleViolation}>
        <ChooseCampaignButton
          isDisabled={isDisabled}
          data-test={'choose-campaign-button'}
          variant={BUTTON_VARIANTS.SECONDARY}
          to={getCampaignEditorExperimentsSectionLink(id, campaignState)}
        >
          {t('chooseCampaign.chooseCampaignButton')}
        </ChooseCampaignButton>
      </Tooltip>
    </BaseCellWrapper>
  );
};
